<template>
    <!--Wrapper - Outer-->
    <div class="wrapper outer">
        <div class="wrapper inner">
            <!--Page-->
            <div class="page">
                <!--Content-->
                <div class="content">
                    <!--Login Page-->
                    <div class="login-page">
                        <div class="page-wrapper primary">
                            <!--Page Body - Primary-->
                            <section class="section page-body primary">
                                <!--Wizard-->
                                <div class="wizard">
                                    <!--Login Form - Primary-->
                                    <section class="section login-form primary">
                                        <div class="section-wrapper primary">
                                            <!--Header Section-->
                                            <div class="login-form-header">
                                                <div class="header-logo">
                                                    <div class="logo">
                                                        <img src="/assets/images/logo/logo-escolarai-a.svg" />
                                                    </div>
                                                </div>
                                                <div class="header-background">
                                                    <div class="background">
                                                        <img src="/assets/images/root/login-form-primary-header-background-1.png" />
                                                    </div>
                                                </div>
                                            </div>

                                            <!--Content Section-->
                                            <div class="login-form-content">
                                                <div class="content-wrapper primary">
                                                    <div class="content-text">
                                                        <div class="title">
                                                            <h2>
                                                               Olá, seja bem-vindo!
                                                            </h2>
                                                            <p>
                                                                Para continuar a ativação da sua conta, por favor, insira suas informações.
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div class="content-form">
                                                        <div class="form-group">
                                                            <div class="form-label">
                                                                <label>
                                                                    Nome
                                                                </label>
                                                            </div>
                                                            <div class="form-input">
                                                                <input type="text" class="form-control" v-model="name" placeholder="Digite seu nome"/>
                                                            </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <div class="form-label">
                                                                <label>
                                                                    Email
                                                                </label>
                                                            </div>
                                                            <div class="form-input">
                                                                <input type="email" class="form-control" v-model="email"  placeholder="Digite seu e-mail"/>
                                                            </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <div class="form-label">
                                                                <label>
                                                                    Senha
                                                                </label>
                                                            </div>
                                                            <div class="form-input">
                                                                <input type="password" class="form-control" v-model="password" placeholder="Digite sua senha"/>
                                                            </div>
                                                           
                                                        </div>
                                                        <div class="form-group">
                                                            <div class="form-label">
                                                                <label>
                                                                    Confirmar Senha
                                                                </label>
                                                            </div>
                                                            <div class="form-input">
                                                                <input type="password" class="form-control" v-model="confirmPassword" placeholder="Confirme sua senha"/>
                                                            </div>
                                                         
                                                        </div>
                                                        <div class="form-button">
                                                            <div class="button">
                                                                <button type="button" class="btn btn-block btn-form" @click="handleLogin">
                                                                   Ativar Conta
                                                                </button>
                                                                <p class="text-center hasAccount">
                                                                    Já possui uma conta? <a href="/">Faça login</a>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>   
                                        </div>
                                    </section>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import UserApi from '@/utils/users';


export default {
    name: 'AtivarConta',
    components: {},
    data() {
        return {
            name: '',
            email: '',
            password: '',
            confirmPassword: '',
            slug: this.$route.params.slug
        };
    },
    computed: {
        ...mapState(['user'])
    },
    methods: {
        ...mapActions(['login', 'storeToken', 'storeRefreshToken', 'storeUser']),
        async handleLogin() {
            try {
                const payload = {
                   "name": this.name,
                    "email": this.email,
                    "token": this.slug,
                    "password": this.password
                };
                const response = await UserApi.activateUser(payload);
                this.storeToken({token: response.access_token});
                this.storeUser({user: response.user}); 
                this.$router.push('/tela-principal');
            } catch (error) {
                console.error('Erro ao ativar conta:', error);
            }
        }
    }
};
</script>
<style scoped lang="scss">
.title p {
    color: white;
}
.wizard .login-form.primary .login-form-content .content-wrapper.primary .content-form .form-button .button .btn-form {
    display: block;
    width: 100% !important;
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 24px;
    text-transform: uppercase;
    padding: .65rem 1rem;
    color: #ffffff;
    background-color: #34a5e4;
}
.hasAccount { 
    color: white;
    margin: 10px;

    a {
        color: white;
    }
}

/* Versão mobile */
@media (max-width: 768px) {
    .wrapper.outer, .wrapper.inner, .page, .content, .login-page, .page-wrapper.primary, .section.page-body.primary, .wizard, .section.login-form.primary, .section-wrapper.primary {
        padding: 0 !important;
        margin: 0 !important;
        width: 100% !important;
        min-width: unset !important;
        max-width: 100vw !important;
        box-sizing: border-box;
    }

    .login-form-header {
        flex-direction: column;
        align-items: center;
        padding: 24px 0 8px 0 !important;
        .header-logo {
            margin-bottom: 12px;
            .logo img {
                width: 120px !important;
                height: auto;
            }
        }
        .header-background {
            display: none;
        }
    }

    .login-form-content {
        padding: 0 12px !important;
        .content-wrapper.primary {
            padding: 0 !important;
        }
    }

    .content-text .title h2 {
        font-size: 1.3rem !important;
        text-align: center;
    }
    .content-text .title p {
        font-size: 1rem !important;
        text-align: center;
    }

    .content-form {
        padding: 0 !important;
        .form-group {
            margin-bottom: 18px !important;
            .form-label label {
                font-size: 1rem !important;
            }
            .form-input input {
                font-size: 1rem !important;
                padding: 10px 12px !important;
                border-radius: 6px !important;
            }
        }
    }

    .form-button {
        margin-top: 10px !important;
        .button .btn-form {
            font-size: 1rem !important;
            padding: 0.8rem 1rem !important;
        }
        .hasAccount {
            font-size: 0.95rem !important;
            margin: 12px 0 0 0 !important;
        }
    }

    /* Remove bordas e sombras que possam existir */
    .section.login-form.primary, .section-wrapper.primary, .login-form-content, .content-wrapper.primary {
        box-shadow: none !important;
        border-radius: 0 !important;
        background: transparent !important;
    }
    .page .page-wrapper.primary .page-body.primary {
        height: auto!important;
    }
}
</style>